import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import {
    onFindYourRep,
    hideFindRepPopup,
    loadLocalRep,
    goToFindLocalRep,
    selectAction
} from '../LocalRep/actions';

import { onGoToNextActionInsideCard, setOverlayPartnerVisible } from '../Widget/actions';

import { isLongText } from '../../components/Shared/commonFunctions';

import { TransitionGroup } from 'react-transition-group';
import CssTransition from '../../components/Transition/CssTransition';

import Overlay from '../Widget/Overlay';
import OverlayPublisher from '../Widget/OverlayPublisher';
import OverlayPartner from '../Widget/OverlayPartner';
import WidgetHeader from '../Widget/WidgetHeader';

import { Container } from '../DefaultStyles/Details';
import { MultiImageBlock } from '../../components/Image/MultiImageBlock';
import FindLocalRepPopup from '../../components/LocalRep/FindLocalRepPopup';
import LocalRepAction from '../../components/LocalRep/LocalRepAction';
import ShareDrawer from '../../components/ShareDrawer';

import { LocalRepState } from '../../utils/enums';
import { width, isPortrait } from '../../utils/size';
import { Placeholders } from '../../utils/fillDynamicText';
import { copyFor, capitalization } from '../../copy/copy';

import {
    relevantRepresentatives,
    joinEnglish
} from '../../utils/localRepresentative/parser';

import defaultImage from '../../assets/images/localRepDefault.jpg';

import {
    Body,
    Content,
    Description,
    Details,
    DetailsContainer,
    Footer,
    PeopleSigned,
    Title
} from '../DefaultStyles/Shared';

import { AutoScalingButtonSet } from '../../components/Buttons/AutoScalingButtonSet';

export class SingleAction extends React.Component {
    constructor(props) {
        super(props);
        this.state = { calcScaleSize: getScaleSize(this.props) };
        if (!props.localRepFound && props.useLocalRepresentative) {
            props.loadLocalRep();
        }
    }

    componentDidMount() {
        window.addEventListener('resize', this.resize);
    }

    componentWillUnmount() {
        window.removeEventListener('resize', this.resize);
    }

    buttonComponent() {
        return (
            <AutoScalingButtonSet>
                {this.props.actions.map(a => (
                    <LocalRepAction
                        isLongText={
                            !isPortrait() &&
                            isLongText(this.props.cardTitle, 40) &&
                            isLongText(this.props.cardDescription, 90)
                        }
                        action={a}
                        text={a.label}
                        key={a.identifier}
                        onClick={() => {
                            if (this.props.localRepFound || !a.useLocalRepresentative) {
                                this.props.selectAction(a.identifier);
                                return this.props.onGoToNextActionInsideCard(
                                    a.identifier,
                                    a.type,
                                    true
                                );
                            } else {
                                this.props.selectAction(a.identifier);
                                this.props.goToFindLocalRep(a.identifier, a.type);
                            }
                        }}
                    />
                ))}
            </AutoScalingButtonSet>
        );
    }

    overlayComponents() {}

    resize = () => {
        this.setState({
            calcScaleSize: getScaleSize(this.props)
        });
    };

    render() {
        return (
            <Container>
                <Overlay />
                <OverlayPublisher />
                <OverlayPartner transitionType="right-to-left" />
                <Body isBlured={this.props.showFindYouRepPopup}>
                    <WidgetHeader />
                    <Content
                        isContactAction={this.props.isContactAction}
                        useLocalRepresentative={this.props.useLocalRepresentative}
                        isSingleAction={this.props.actions.length === 1}
                    >
                        <Title
                            isShortText={!isLongText(this.props.cardTitle, 28)}
                            isLongText={isLongText(this.props.cardTitle, 60)}
                            isExtraLongText={isLongText(this.props.cardTitle, 95)}
                            isLocalRepLoading={this.props.isLocalRepLoading}
                            onClick={e =>
                                this.props.setOverlayPartnerVisible(true, e, false)
                            }
                            dangerouslySetInnerHTML={{
                                __html: this.props.cardTitle
                            }}
                        />
                        <DetailsContainer>
                            <MultiImageBlock
                                isLongTitle={isLongText(this.props.cardTitle, 40)}
                                isLocalRepLoading={this.props.isLocalRepLoading}
                                imgSources={
                                    this.props.useLocalRepresentative
                                        ? this.props.localRepImages.length > 0
                                            ? this.props.localRepImages
                                            : [defaultImage]
                                        : this.props.pictureUrl
                                        ? [this.props.pictureUrl]
                                        : []
                                }
                            />
                            <Details
                                hasPhoto={
                                    this.props.useLocalRepresentative ||
                                    this.props.pictureUrl
                                }
                            >
                                {this.props.cardDescription.length > 0 && (
                                    <Description
                                        isLocalRepLoading={this.props.isLocalRepLoading}
                                        dangerouslySetInnerHTML={{
                                            __html: this.props.cardDescription
                                        }}
                                        isSingleAction={this.props.actions.length === 1}
                                        isLongText={isLongText(
                                            this.props.cardDescription,
                                            90
                                        )}
                                        isExtraLongText={isLongText(
                                            this.props.cardDescription,
                                            160
                                        )}
                                        onClick={e =>
                                            this.props.setOverlayPartnerVisible(
                                                true,
                                                e,
                                                false
                                            )
                                        }
                                    />
                                )}
                                {!!this.props.noOfAnswers.length && (
                                    <PeopleSigned>
                                        {this.props.noOfAnswers}{' '}
                                        {copyFor(
                                            'miscellaneous',
                                            'numAnswered',
                                            this.props.actions[0].type,
                                            capitalization.all
                                        )}
                                    </PeopleSigned>
                                )}
                            </Details>
                        </DetailsContainer>
                    </Content>
                    {this.buttonComponent()}
                    <Footer>
                        <ShareDrawer backgroundColor={'#fff'} />
                    </Footer>
                </Body>
                <TransitionGroup>
                    {this.props.showFindYouRepPopup && (
                        <CssTransition key="alert" in={this.props.showFindYouRepPopup}>
                            <FindLocalRepPopup
                                hideFindRepPopup={this.props.hideFindRepPopup}
                                onSubmit={data => this.props.loadLocalRep(data, true)}
                            />
                        </CssTransition>
                    )}
                </TransitionGroup>
                {this.overlayComponents()}
            </Container>
        );
    }
}

SingleAction.propTypes = {
    onGoToNextActionInsideCard: PropTypes.func.isRequired,
    goToFindLocalRep: PropTypes.func.isRequired,
    hideFindRepPopup: PropTypes.func.isRequired,
    loadLocalRep: PropTypes.func.isRequired,
    showFindYouRepPopup: PropTypes.bool.isRequired,
    cardTitle: PropTypes.string.isRequired,
    cardDescription: PropTypes.string.isRequired,
    localRepImages: PropTypes.array.isRequired,
    actions: PropTypes.array.isRequired,
    localRepFound: PropTypes.bool.isRequired,
    isLocalRepLoading: PropTypes.bool,
    isContactAction: PropTypes.bool,
    noOfAnswers: PropTypes.string.isRequired,
    setOverlayPartnerVisible: PropTypes.func.isRequired,
    pictureUrl: PropTypes.string,
    selectAction: PropTypes.func.isRequired,
    useLocalRepresentative: PropTypes.bool
};

const pictureUrl = state => {
    const picture = state.widget.pictures.find(
        a => a.recipientPictureId === state.widget.activeAction.recipientPictureId
    );
    return (picture || {}).pictureUrl;
};

const getScaleSize = props => {
    let noOfRows =
        Math.ceil(props.cardTitle.length / (width() / 11)) +
        Math.ceil(props.cardDescription.length / (width() / 11));
    return 1 - Math.max(noOfRows - 5, 0) * 0.0285;
};

export const parseSingleActionProps = state => {
    const reps = state.localRep.localRepData
        ? relevantRepresentatives(
              state.widget.activeAction.localRepresentativeState,
              state.localRep.localRepData.representative
          )
        : [];

    return {
        isLocalRepLoading: state.localRep.isLocalRepLoading,
        localRepFound: state.localRep.localRepData.representative !== undefined,
        localRepImages: reps.map(rep => rep.photoUrl || defaultImage),
        pictureUrl: pictureUrl(state),
        showFindYouRepPopup: state.localRep.showFindYouRepPopup,
        cardTitle: state.widget.cards[state.widget.activeAction.order - 1].heading
            .replace(/@articleUrl/g, state.widget.articleUrl)
            .replace(
                new RegExp(Placeholders.PostalCodePlaceholder, 'g'),
                state.localRep.localRepData.representative !== undefined
                    ? state.localRep.localRepData.postalCode
                    : ''
            )
            .replace(
                new RegExp(
                    state.widget.activeAction.type === 'tweet'
                        ? Placeholders.TwitterMentionPlaceholder
                        : Placeholders.LocalRepresentative,
                    'g'
                ),
                state.localRep.localRepData.representative !== undefined
                    ? joinEnglish(
                          reps.map(
                              rep =>
                                  `${rep.shortName} (${
                                      rep.level === 2
                                          ? rep.partyIdentifier +
                                            '-' +
                                            state.localRep.localRepData.state
                                          : state.localRep.localRepData.state +
                                            '-' +
                                            state.localRep.localRepData.district
                                  })`
                          )
                      )
                    : `Speakable`
            )
            .replace(
                new RegExp(Placeholders.TwitterMentionPlaceholder, 'g'),
                state.localRep.localRepData.representative !== undefined
                    ? joinEnglish(reps.map(rep => rep.fullName || rep.twitterMention))
                    : '@Speakable'
            ),
        useLocalRepresentative:
            !!state.widget.activeAction.localRepresentativeState &&
            state.widget.activeAction.localRepresentativeState !== LocalRepState.disabled,
        isContactAction:
            state.widget.activeAction.type === 'email' ||
            state.widget.activeAction.type === 'tweet' ||
            state.widget.activeAction.type === 'call' ||
            state.widget.activeAction.type === 'petition',
        regularRowSize: state.widget.regularRowSize,
        noOfAnswers: !!state.widget.activeAction.noOfAnswers
            ? state.widget.activeAction.noOfAnswers.toLocaleString()
            : '',
        actions: state.widget.actions
            .filter(function(a) {
                return state.widget.activeAction.type === 'petition'
                    ? a.id === state.widget.activeAction.id
                    : a.order === state.widget.activeAction.order &&
                          a.order.type === state.widget.activeAction.order.type;
            })
            .map(a => ({
                label:
                    a.customButtonText !== undefined
                        ? a.customButtonText
                        : copyFor('buttons', 'start', a.type),
                identifier: a.identifier,
                type: a.type,
                name: a.name,
                useLocalRepresentative:
                    state.widget.activeAction.localRepresentativeState !==
                    LocalRepState.disabled,
                position: state.widget.cards[
                    state.widget.activeAction.order - 1
                ].actions.indexOf(a)
            }))
            .slice(0, 3),
        cardDescription: state.widget.cards[
            state.widget.activeAction.order - 1
        ].subHeading
            .replace(new RegExp(Placeholders.ArticleUrl, 'g'), state.widget.articleUrl)
            .replace(
                new RegExp(Placeholders.PostalCodePlaceholder, 'g'),
                state.localRep.localRepData.representative !== undefined
                    ? state.localRep.localRepData.postalCode
                    : ''
            )
            .replace(
                new RegExp(
                    state.widget.activeAction.type === 'tweet'
                        ? Placeholders.TwitterMentionPlaceholder
                        : Placeholders.LocalRepresentative,
                    'g'
                ),
                state.localRep.localRepData.representative !== undefined
                    ? joinEnglish(
                          reps.map(
                              rep =>
                                  `${rep.shortName} (${
                                      rep.level === 2
                                          ? rep.partyIdentifier +
                                            '-' +
                                            state.localRep.localRepData.state
                                          : state.localRep.localRepData.state +
                                            '-' +
                                            state.localRep.localRepData.district
                                  })`
                          )
                      )
                    : `Congress`
            )
            .replace(
                new RegExp(Placeholders.TwitterMentionPlaceholder, 'g'),
                state.localRep.localRepData.representative !== undefined
                    ? joinEnglish(reps.map(rep => rep.fullName || rep.twitterMention))
                    : '@Speakable'
            )
    };
};

export const requiredFunctionsForSingleAction = {
    onFindYourRep,
    hideFindRepPopup,
    loadLocalRep,
    onGoToNextActionInsideCard,
    goToFindLocalRep,
    setOverlayPartnerVisible,
    selectAction
};

export default connect(
    state => parseSingleActionProps(state),
    requiredFunctionsForSingleAction
)(SingleAction);



// WEBPACK FOOTER //
// ./src/containers/SingleAction/SingleActionDetails.jsx